export class CookieHelper {

    static writeLocalCookie(name: string, value: string, expiration: number): void {
        CookieHelper.write(name, value, location.hostname, expiration);
    }

    static cookiesEnabled(): boolean {
        let hasCookies: boolean = navigator.cookieEnabled;
        if (typeof navigator.cookieEnabled === 'undefined' && !hasCookies) {
            document.cookie = 'check_cookies';
            hasCookies = document.cookie.indexOf('check_cookies') !== -1;
        }
        return hasCookies === true;
    }

    static write(name: string, value: string, domain: string, expiration: number): void {
        let expires: string = '';
        if (expiration) {
            expiration = Math.abs(expiration);
            let date: Date = new Date();
            date.setTime(date.getTime() + expiration);
            expires = '; expires=' + date.toUTCString().replace('UTC', 'GMT');
        }
        domain = '; domain=' + (domain || location.hostname);
        document.cookie = name + '=' + (value || '') + expires + '; path=/' + domain;
    }

    static read(name: string): string {
        let nameEQ: string = name + '=';
        let ca: string[] = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c: string = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) == 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    }

    static delete(name: string): void {
        document.cookie = name + '=; Max-Age=-99999999;';
    }
}
